<template>
	<section class="prebuild-specs" id="prebuild-specs">
		<div class="container">
			<img
				class="prebuild-specs__heading-icon"
				src="/images/prebuild-series/specs-table-icon.svg"
				alt=""
			>
			<h3 class="prebuild-specs__heading">
				The PCs
			</h3>

			<div class="prebuild-specs__mobile-series-picker">
				<prebuild-model-picker
					show-price
					:prebuilds-list="prebuilds"
					:current-prebuild-id="currentPrebuildId"
					@select="setCurrentPrebuild"
				/>
			</div>

			<div class="specs-table">
				<specs-prebuild
					v-for="(prebuild, index) in prebuilds"
					:key="prebuild.id"
					:index="index"
					:show-more-specs="showMoreSpecs"
					:prebuild="prebuild"
					:current-prebuild-id="currentPrebuildId"
					:current-variant-id="currentVariantId"
					:class="{ 'gray-bg': isMiddleColumn(index) }"
				/>
			</div>

			<button
				@click="showMoreSpecs = !showMoreSpecs"
				class="prebuild-specs__show-more btn"
			>
				{{ showMoreSpecs ? "Show less" : "Show more" }}
			</button>

			<sticky-banner-slide
				class="prebuild-specs__sticky-model-picker"
				trigger-element="#prebuild-specs"
				:offset="120"
				end-element=".bld-features"
				:end-element-offset="-150"
			>
				<div class="prebuild-specs__sticky-model-picker__container">
					<prebuild-model-picker
						show-price
						:prebuilds-list="prebuilds"
						:current-prebuild-id="currentPrebuildId"
						@select="setCurrentPrebuild"
					/>
				</div>
			</sticky-banner-slide>
		</div>
	</section>
</template>

<script>
import SpecsPrebuild from "./spec-prebuild/index";
import PrebuildModelPicker from "../prebuild-model-picker";
import StickyBannerSlide from "@c/generals/sticky-banner-slide.vue";

export default {
	name: "PrebuildSpecs",
	inject: ["currentPrebuild"],
	components: {
		SpecsPrebuild,
		PrebuildModelPicker,
		StickyBannerSlide
	},
	props: {
		prebuilds: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	data() {
		return {
			showMoreSpecs: false
		};
	},
	computed: {
		getCurrentPrebuild() {
			const { getPrebuild } = this.currentPrebuild;
			return getPrebuild();
		},
		getCurrentVariant() {
			const { getVariant } = this.currentPrebuild;
			return getVariant();
		},
		currentVariantId() {
			const { id = "" } = this.getCurrentVariant;
			return id;
		},
		currentPrebuildId() {
			const { id = "" } = this.getCurrentPrebuild;
			return id;
		}
	},
	methods: {
		isMiddleColumn(index) {
			const MIDDLE_COLUMN_INDEX = 1;
			return index === MIDDLE_COLUMN_INDEX;
		},
		setCurrentPrebuild(payload) {
			const { setPrebuild } = this.currentPrebuild;
			setPrebuild(payload);
		}
	}
};
</script>

<style lang="scss" scoped>
.prebuild-specs {
	background-color: #fff;
	padding: 35px 0 40px;

	@media (min-width: 991px) {
		padding: 70px 0;
	}

	&__heading-icon {
		width: 50px;
		margin-bottom: 20px;

		@media (min-width: 580px) and (max-width: 991px) {
			display: block;
			margin: 0 auto 15px;
		}
	}

	&__heading {
		color: #444259;
		font-size: 32px;
		font-weight: bold;
		letter-spacing: 0;
		margin: 0 0 25px;

		@media (min-width: 580px) and (max-width: 991px) {
			text-align: center;
		}

		@media (min-width: 991px) {
			margin: 0 0 5px;
		}
	}

	&__show-more {
		display: block;
		margin-right: auto;
		margin-left: auto;
		border: 1px solid #72178f;
		border-radius: 2px;
		color: #72178f;
		background: transparent;
		font-size: 16px;
		font-weight: bold;
		padding: 5px 30px;
		text-transform: inherit;
		width: 150px;

		@media (min-width: 991px) {
			margin-right: 0;
		}

		@media (hover: hover) {
			&:hover {
				color: #fff;
				background: #72178f;
			}
		}
	}

	&__mobile-series-picker {
		margin: 0 -15px;
		padding: 0 15px 0;
		border-bottom: solid 1px #dbdde0;
		display: block;

		@media (min-width: 580px) and (max-width: 991px) {
			margin: 0 -100%;
		}

		@media (min-width: 991px) {
			display: none;
		}
	}

	&__sticky-model-picker {
		@media (min-width: 991px) {
			display: none;
		}

		&__container {
			min-height: 110px;
			background-color: #fff;
			border-bottom: solid 1px #dbdde0;
			padding: 25px 15px 0;
		}
	}

	.specs-table {
		width: 100%;
		margin-bottom: 30px;

		@media (min-width: 580px) and (max-width: 991px) {
			width: 460px;
			margin: 0 auto 30px;
		}

		@media (min-width: 991px) {
			display: grid;
			grid-template-columns: minmax(auto, 435px) repeat(2, auto);
		}

		.gray-bg {
			@media (min-width: 991px) {
				background-color: #f3f3f3;
			}
		}
	}
}

.prebuild-specs::v-deep {
	.sticky-banner {
		z-index: 120;
	}

	.prebuild-specs__mobile-series-picker,
	.sticky-banner {
		.model-picker {
			@media (min-width: 580px) and (max-width: 991px) {
				max-width: 460px;
				margin: 0 auto;
			}

			.cross {
				right: -7px;

				@media (min-width: 580px) and (max-width: 991px) {
					// Safari Only
					@media not all and (min-resolution: 0.001dpcm) {
						right: -9px;
					}
				}
			}

			.diamond {
				right: 5px;

				@media (min-width: 580px) and (max-width: 991px) {
					// Safari Only
					@media not all and (min-resolution: 0.001dpcm) {
						right: 3px;
					}
				}
			}
		}
	}
}
</style>
